import { render, staticRenderFns } from "./PrizeDetail.vue?vue&type=template&id=9b573cca&scoped=true"
import script from "./PrizeDetail.vue?vue&type=script&lang=js"
export * from "./PrizeDetail.vue?vue&type=script&lang=js"
import style0 from "./PrizeDetail.vue?vue&type=style&index=0&id=9b573cca&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b573cca",
  null
  
)

export default component.exports